/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Password_HintInputs */

const en_auth_signup_password_hint = /** @type {(inputs: Auth_Signup_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum 8 characters.`)
};

const pl_auth_signup_password_hint = /** @type {(inputs: Auth_Signup_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum 8 znaków.`)
};

/**
* | output |
* | --- |
* | "Minimum 8 characters." |
*
* @param {Auth_Signup_Password_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_password_hint = /** @type {((inputs?: Auth_Signup_Password_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Password_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_password_hint(inputs)
	return en_auth_signup_password_hint(inputs)
});